/* Copyright (c) 2022-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { When } from "react-if";
import { FlexContainer, theme } from "@nordcloud/gnui";
import { TooltipIconBox } from "~/components";
import { StyledTextItem } from "../ReservationsCoverageTable/styles";

type ReservationTooltipRowProps = {
  infoLabel: React.ReactNode;
  infoValue: React.ReactNode;
  color?: string;
};

export function ReservationTooltipRow({
  infoLabel,
  infoValue,
  color,
}: ReservationTooltipRowProps) {
  const showTooltipIconBox = color != null;

  return (
    <FlexContainer direction="row">
      <When condition={showTooltipIconBox}>
        <TooltipIconBox color={color ?? "primary"} />
      </When>
      <StyledTextItem>{infoLabel}:</StyledTextItem>
      <StyledTextItem align="right" marginLeft={theme.spacing.spacing02}>
        {infoValue}
      </StyledTextItem>
    </FlexContainer>
  );
}
